import { Injectable, inject } from '@angular/core';
import { StorageV2Service, UserV2Service, StoreV2, User } from '@schenck/rotec-components';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { FilterApi } from 'src/api/filterApi';

@Injectable()
export class EditorsService extends StoreV2<User[]> {
  private readonly filterApi = inject(FilterApi);
  private readonly userService = inject(UserV2Service);

  constructor() {
    const storageService = inject(StorageV2Service);

    super([], 'UserService', { storageService, name: 'UserService' });

    this.userService.currentUser$
      .pipe(filter((user: User) => !!user))
      .subscribe(() => this.getUsers$());
  }

  public getUserNames$(): Observable<string[]> {
    return this.state$.pipe(
      map((users) => users.map((user) => user.firstName + ' ' + user.lastName))
    );
  }

  public getIdFromUserName(userName: string): string {
    const names = userName.split(' ');
    const user = this.state.find(
      (_user) => _user.firstName === names[0] && _user.lastName === names[1]
    );
    return user ? user.id : '';
  }

  private getUsers$(): void {
    this.filterApi
      .getUsers$()
      .pipe(map((users) => users.filter((user) => !!user.firstName && !!user.lastName)))
      .subscribe((user) => this.setState('get User', user));
  }
}
